﻿/* UOE Mobile Nav
 * version 2.0
 * 
 * Last updated 7-21-15 by CB3
 * 
 * Example usage with all defaults (in main.js)
 * new UOE_MobileNav().Initialize();
 * 
 * More advanced usage? Read comments below.
 */

import viewport from '@storyous/responsive-bootstrap-toolkit/bootstrap-toolkit';

    //prevent double-loading
    //if (typeof UOE_MobileNav === 'function') return UOE_MobileNav;

    var UOE_MobileNav = function () { };

    UOE_MobileNav.prototype = {
        Initialize: function (options) {

            viewport.use('bootstrap');
            
            //If you want to somehow use multiple collapsible navs, you should
            //plan to all of these except maybe navCollapsedBreakpoint for at least one 
            //of them, and navToggleListeners will need to be more restricted in most cases.
            var defaults = {
                //a jQuery selector: where to find the core nav elements, usually a <nav> tag.
                //this should be in the normal "desktop" location; the parent of this element will
                //be used to put the nav back where it belongs after a resize
                navContents: "#primaryNav",
                //a jQuery selector: where to put the nav when the mobile "menu" button is clicked.
                //(mobile-nav-open would be better, but many existing sites use #nav-placeholder)
                navOpenDestination: "#nav-placeholder",
                //a jQuery selector: where to put the nav on mobile until the button is clicked
                navClosedDestination: "#mobile-nav-closed",
                //the bootstrap code for the highest breakpoint at which your nav is collapsed,
                //typically sm (could be xs, md, lg).
                navCollapsedBreakpoint: "sm",
                //a jQuery selector: elements that will trigger a toggle 
                //(comma-separate multiple selectors in a single string)
                navToggleListeners: ".uoe-navbar-toggle",
            };

            this.Settings = $.extend(true, defaults, options);

            this.IsOpen = false;

            var MobileNav = this;




            $(this.Settings.navToggleListeners).click(function () {
                if (MobileNav.IsOpen) {
                    MobileNav.Close();

                    //return the button previously used to its proper location 
                    //then set the focus on it.
                    MobileNav.ResetToggleButton();


                } else {
                    //since you might have more than one handler, we're going to pick up the one you used
                    //aka $(this) and move it. We'll note which it is.
                    MobileNav.LastOpenTrigger = $(this);
                    MobileNav.LastOpenTriggerParent = $(this).parent();
                    $(this).appendTo(MobileNav.Settings.navOpenDestination);

                    MobileNav.Open();
                }
            });


            //finally, check if we need to move the nav down now because we're 
            //on mobile. Closing the nav is a shortcut to put the nav in the right
            //spot.
            $(document).ready(function () {

                //note the original viewport setting. window.resize
                //and viewport.changed may fire for things other than actual legit resize 
                //events. for instance, window.resize was firing when the off-canvas nav
                //was expanded on chrome android.

                MobileNav.__origViewport = viewport.current();

                //note the correct parent of the contents, we may need it later
                MobileNav.navOriginalParent = $(MobileNav.Settings.navContents).parent();
                MobileNav.navOriginalCSS = $(MobileNav.Settings.navContents).attr('class');

                if (viewport.is('<=' + MobileNav.Settings.navCollapsedBreakpoint)) {
                    MobileNav.Close();
                }
                //bind to window resize to monitor for changes
                $(window).resize(function () {
                    //don't rely on viewport.changed; do the comparison.

                    if (MobileNav.__origViewport !== viewport.current()) {
                        //reset the origViewport!
                        MobileNav.__origViewport = viewport.current();
                        if (viewport.is('<=' + MobileNav.Settings.navCollapsedBreakpoint)) {
                            MobileNav.Close();
                            MobileNav.ResetToggleButton();
                            //yes it may be open, but on true touch devices, you're not resizing the 
                            //window except via portait/landscape flip, and that's worth reclosing it.
                        } else {
                            //return to desktop configuration by moving it to its original parent
                            $(MobileNav.Settings.navContents).appendTo(MobileNav.navOriginalParent);
                            MobileNav.IsOpen = false;
                        }
                    }
                });
            });

        },

        //calling this directly is unusual, normally it is only called when the viewport crosses 
        //a boundary or you actually close the nav by clicking the button.
        ResetToggleButton: function () {
            $(this.LastOpenTrigger).appendTo(this.LastOpenTriggerParent).focus();
        },

        //Note that just calling Open directly will not move a button, so it may be hard
        //to ensure correct keyboard behavior. We will set the focus to the first
        //valid element in the now-open nav, but it may be hard to close the nav.
        Open: function () {
            $("body").removeClass("navbar-inactive").addClass("navbar-active");
            //our styles work with navbar-inverse. don't like it? tough.
            $(this.Settings.navContents).removeClass('navbar-default').addClass('navbar-inverse').appendTo(this.Settings.navOpenDestination);

            //update aria -- set the "expanded" property on all togglers to true
            //since the nav itself is always expanded, just in a different spot, we do not feel that we should actually change its expanded property
            $(this.Settings.navToggleListeners).attr('aria-expanded', 'true');
            this.IsOpen = true;

            //set the tab focus on the first focusable element. here we make a small concession that we 
            //will not cover weird cases where you put tabindex on something unusual.

            //$(this.Settings.navContents).find('input, a, button').filter(":visible").eq(0).focus();

            //by focusing on the button instead of the search, we avoid popping up the mobile keyboard, which would obscure 
            //most of the nav
            $(this.LastOpenTrigger).focus();
        },

        //Note that just calling Close directly will not do any magic like move the button
        //or reset focus. 
        Close: function () {
            $("body").removeClass("navbar-active").addClass("navbar-inactive");
            $(this.Settings.navContents).attr('class', this.navOriginalCSS).appendTo(this.Settings.navClosedDestination);

            //update aria -- set the "expanded" property on all togglers to false
            //since the nav itself is always expanded, just in a different spot, we do not feel that we should actually change its expanded property
            $(this.Settings.navToggleListeners).attr('aria-expanded', 'false');
            this.IsOpen = false;
        }
    };


export default UOE_MobileNav;